<template>
    <div class="container">
        <div class="common-header-wrap">
            <mt-header title="子帐号管理" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>
        <div class="main-content">
        <div  @click="goSellerAccountList">
            <flex-line :is-link="true" :show-border="true"><span class="line-name">账户列表</span></flex-line>
        </div>
        <div  @click="goSellerAccountGroupList">
            <flex-line :is-link="true" :show-border="true"><span class="line-name">账户组</span></flex-line>
        </div>
        <div  @click="goSellerLogList">
            <flex-line :is-link="true" :show-border="true"><span class="line-name">账户日志</span></flex-line>
        </div>
        </div>
    </div>
</template>

<script>
import flexLine from '../../flexLine'
export default {
  name: 'Index',
    components:{flexLine,},
  methods: {
    goSellerAccountList () {
      this.$router.push({ name: 'SellerAccountList' })
    },
    goSellerAccountGroupList () {
      this.$router.push({ name: 'SellerAccountGroupList' })
    },
    goSellerLogList () {
      this.$router.push({ name: 'SellerLogList' })
    }
  }
}
</script>

<style scoped lang="scss">
.main-content{background: #fff;padding:0 $pageSpace}

</style>
